module.exports = __webpack_public_path__ + "img/auditwait_bgimg.016bf241.png";